import React, { useEffect, useRef, useState } from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import ReactSelect from "react-select";
import { people, post } from "../../config/imagesLink";
import axios from "../../API/axios";
import { getShortMutualUserInfo } from "../../Services/apiService";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import ModalForGuest from "../ModalForGuest";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import SuccessToast from "../SuccessToast";
import { GridCardSkeleton } from "@skeleton";
import { ShimmerThumbnail } from "react-shimmer-effects";
import PeopleInteraction from "./PeopleInteraction";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { Helmet } from "react-helmet";
import PeopleFeedAds from "./PeopleFeedAds";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";

const People = () => {
	const { t } = useTranslation();
	const guestModeData = localStorage.getItem("guestMode");
	const userid = localStorage.getItem("userUid");
	const [isError, setIsError] = useState(false);
	const [searchUserName, setSearchUserName] = useState("");
	const [debouncedSearch, setDebouncedSearch] = useState(searchUserName);
	const language = localStorage.getItem("Lang");
	const [toastMessage, setToastMessage] = useState("");
	const [showToast, setShowToast] = useState(false);

	const [warningToastMessage, setWarningToastMessage] = useState("");
	const [showWarningToast, setShowWarningToast] = useState(false);

	const [ErrorToastMessage, setErrorToastMessage] = useState("");
	const [showErrorToast, setShowErrorToast] = useState(false);

	console.log("searchUserName", searchUserName);
	const options = [
		{ value: "apple", label: "Apple" },
		{ value: "banana", label: "Banana" },
		{ value: "cherry", label: "Cherry" },
		{ value: "grape", label: "Grape" },
	];
	const sessionId = localStorage.getItem("sessionId");
	const userUid = localStorage.getItem("userUid");

	//************************User Profile Get Start  ************************//
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [isLoading, setIsLoading] = useState(true);
	const [hasMoreData, setHasMoreData] = useState(true);
	const [userList, setuserList] = useState([]);
	const [searchuserList, setSearchuserList] = useState([]);
	const [nextBatchLoading, setNextBatchLoading] = useState("");
	const [isSearchMode, setIsSearchMode] = useState(false);
	const requestIdRef = useRef(0);

	const getUserProfileList = (page, debouncedSearch) => {
		setNextBatchLoading(true);
		const currentRequestId = ++requestIdRef.current;
		const data = {
			deviceType: "Web",
			pageNumber: page,
			pageSize: 24,
		};
		axios
			.post(`UserProfile/GetAllUserList?Search=${debouncedSearch}`, data)
			.then((response) => {
				// Ignore stale responses from previous searches
				if (currentRequestId !== requestIdRef.current) return;

				setIsError(false);
				setIsLoading(false);

				const totalPages = response.data.responseData.paging.totalPages;
				setTotalPages(totalPages);
				const newPosts = response.data.responseData.userList;

				if (debouncedSearch !== "") {
					setuserList([]);
					setSearchuserList(newPosts);
				} else {
					setSearchuserList([]);
					setuserList((prev) => {
						const userSet = new Set(prev?.map((user) => user?.userUid));
						const uniqueNewPosts = newPosts.filter(
							(user) => !userSet.has(user?.userUid)
						);
						return [...prev, ...uniqueNewPosts];
					});
				}

				// Set hasMoreData and nextBatchLoading in one condition
				setHasMoreData(page < totalPages);
				setNextBatchLoading(false);

				console.log("all post data", newPosts);
			})
			.catch((error) => {
				if (currentRequestId !== requestIdRef.current) return;
				if (error.response && error.response.status === 404) {
					setIsError(true);
				} else {
					console.log(error);
				}
				setNextBatchLoading(false);
			});
	};

	useEffect(() => {
		// When search is cleared, skip debounce and fetch immediately
		if (searchUserName === "") {
			setDebouncedSearch("");
			return;
		}
		const handler = setTimeout(() => {
			setDebouncedSearch(searchUserName);
		}, 1000);

		return () => clearTimeout(handler);
	}, [searchUserName]);

	// Reset page and lists when search term changes
	useEffect(() => {
		setPage(1);
		setuserList([]);
		setSearchuserList([]);
		setHasMoreData(true);
	}, [debouncedSearch]);

	// Fetch user list when page or search changes
	useEffect(() => {
		if (hasMoreData || page === 1) {
			getUserProfileList(page, debouncedSearch);
		}
	}, [page, debouncedSearch]);

	const getUserListWithAds = (posts) => {
		const result = [];
		posts.forEach((post, index) => {
			result.push(post);
			// Insert AdComponent after every 12 posts
			if ((index + 1) % 12 === 0) {
				result.push({ isAd: true }); // Add a placeholder object for ads
			}
		});
		return result;
	};

	const UserWithAds = getUserListWithAds(userList);
	//************************User Profile Get End  ************************//

	//************************ Follow User Start  ************************//

	const [followedCompanies, setFollowedCompanies] = useState({});

	const [userID, setUserID] = useState("");

	const [showModal, setShowModal] = useState(false);
	const handleCloseModal = () => setShowModal(false);
	const handleShow = () => setShowModal(true);
	const FollowUser = async (id) => {
		const data = {
			deviceType: "Web",
			sessionId: sessionId,
			userUID: id,
			langKey: language === "en" ? "" : language,
		};
		try {
			await axios.post("UserFollow/FollowUser", data).then((resData) => {
				setFollowedCompanies((prev) => ({ ...prev, [id]: true }));
				setToastMessage(resData.data.message);
				setShowToast(true);
				// Optionally, you can update the userList or searchuserList state if needed
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				setWarningToastMessage(e.response.data.message);
				setShowWarningToast(true);
			} else {
				setErrorToastMessage(e.response.data.message);
				setShowErrorToast(true);
			}
		}
	};

	// Unfollow User
	const unFollowUser = async () => {
		const responseData = {
			deviceType: "Web",
			sessionId: sessionId,
			userUID: selectedUserId,
			langKey: language === "en" ? "" : language,
		};
		try {
			await axios.post(`UserFollow/UnfollowUser`, responseData).then((res) => {
				setFollowedCompanies((prev) => ({ ...prev, [selectedUserId]: false }));
				setToastMessage(res.data.message);
				setShowToast(true);
				setShowModal(false);
				// Optionally, you can update the userList or searchuserList state if needed
			});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				setWarningToastMessage(e.response.data.message);
				setShowWarningToast(true);
			} else {
				setErrorToastMessage(e.response.data.message);
				setShowErrorToast(true);
			}
		}
	};

	const [followModal, setFollowModal] = useState(false);
	const closeModalData = () => {
		setFollowModal(false);
	};
	//************************ Unfollow User  End  ************************//

	const handelInfiniteScroll = async () => {
		try {
			if (
				window.innerHeight + document.documentElement.scrollTop + 1 >=
				document.documentElement.scrollHeight
			) {
				setPage((prev) => prev + 1);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", handelInfiniteScroll);
		return () => window.removeEventListener("scroll", handelInfiniteScroll);
	}, []);

	const [showDropdown, setShowDropdown] = useState(false);
	const dropdownRef = useRef(null);
	const [selectedUserId, setSelectedUserId] = useState(null);

	const handleToggleDropdown = (index) => {
		setShowDropdown((prev) => (prev === index ? null : index));
	};

	const handleShowModal = (item) => {
		setSelectedItem(item);
		console.log("unfollow item", item);
		setSelectedUserId(item.userUid);
		setShowModal(true);
	};
	//   console.log("selectedUserId", selectedUserId);

	const handleUnfollowCloseModal = () => {
		setShowModal(false);
		setSelectedItem(null);
	};

	const handleConfirmAction = () => {
		unFollowUser();
		handleUnfollowCloseModal();
	};

	const handleClickOutside = (event) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
			setShowDropdown(null);
		}
	};
	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	//   const [showModal, setShowModal] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);

	useEffect(() => {
		if (showModal) {
			document.body.style.overflow = "hidden";
			document.documentElement.style.overflow = "hidden";
			document.body.classList.add("modal-open"); // When a modal opens
		} else {
			document.body.style.overflow = "unset";
			document.documentElement.style.overflow = "";
			document.body.classList.remove("modal-open"); // When a modal closes
		}
	}, [showModal]);

	useEffect(() => {
		const scrollToTop = () => {
			window.scrollTo({ top: 0, behavior: "smooth" });
		};
		scrollToTop();
	}, []);

	const [shortMutualList, setShortMutualList] = useState({});
	const fetchedUserIds = useRef(new Set()); // keeps track of fetched users
	const fetchTimerRef = useRef(null); // Timer for batching requests

	useEffect(() => {
		if (!sessionId) return;

		// Collect new users that need to be fetched
		const usersToFetch = [];
		
		if (userList && userList.length > 0) {
			userList.forEach((item) => {
				if (!fetchedUserIds.current.has(item.userUid) && !shortMutualList[item.userUid]) {
					usersToFetch.push(item.userUid);
					fetchedUserIds.current.add(item.userUid);
				}
			});
		}

		// Batch fetch: Clear previous timer and set a new one
		if (usersToFetch.length > 0) {
			if (fetchTimerRef.current) {
				clearTimeout(fetchTimerRef.current);
			}

			fetchTimerRef.current = setTimeout(() => {
				usersToFetch.forEach((userId) => {
					fetchShortMutualList(userId);
				});
			}, 300); // Debounce fetching by 300ms
		}

		return () => {
			if (fetchTimerRef.current) {
				clearTimeout(fetchTimerRef.current);
			}
		};
	}, [userList]);

	const fetchShortMutualList = async (id) => {
		if (!sessionId) return;

		// Skip if already fetched
		if (shortMutualList[id]) {
			return;
		}

		try {
			const responseData = await getShortMutualUserInfo(id);

			setShortMutualList((prevState) => ({
				...prevState,
				[id]: responseData,
			}));
		} catch (error) {
			console.log(error);
			// Mark as failed to avoid retry storms
			setShortMutualList((prevState) => ({
				...prevState,
				[id]: null,
			}));
		}
	};

	const handleProfileImageError = (e) => {
		if (!e || !e.target) return;
		e.target.onerror = null;
		e.target.src = people.DefaultProfile;
	};

	return (
		<>
			<Helmet>
				<title>People | Welinkjobs </title>
				<meta
					name="description"
					content="Enhance your professional network on Welinkjobs. Connect with top talent and explore new career opportunities."
				/>
				{/* <meta name="keywords" content="react, meta tags, seo" /> */}
				{/* <meta name="author" content="Your Name" /> */}
				<meta
					property="og:title"
					content="Connect with Professionals | People on Welinkjobs"
				/>
				<meta
					property="og:description"
					content="Enhance your professional network on Welinkjobs. Connect with top talent and explore new career opportunities."
				/>
				{/* <meta property="og:image" content="https://example.com/image.jpg" /> */}
				<meta property="og:url" content="https://welinkjobs.com/People" />
			</Helmet>
			<div className="friend-main-container mt-3">
				<Row>
					<div className="headerSection  d-block d-md-flex justify-content-between">
						<Col md={7}>
							<div className="friendsHeaderText">
								<h1>{t("People.People")}</h1>
							</div>
						</Col>
						<Col md={5}>
							<div>
								<input
									type="email"
									className="form-control p-2"
									id="exampleInputEmail1"
									aria-describedby="emailHelp"
									placeholder={t("People.Search user")}
									onChange={(e) => {
										setSearchUserName(e.target.value);
										// getUserProfileList();
									}}
									value={searchUserName}
								/>
							</div>
						</Col>
					</div>
				</Row>
				<div className="frindsCardContainer">
					{/* <ShimmerDiv height={100} width={100} /> */}
					{/* <div className="shimmer-cont">
            <div className="shimmer-header d-flex">
              <ShimmerDiv height={60} width={60} rounded={50} />
              <div className="shimmer-title ms-3">
                <ShimmerTitle line={2} gap={8} />
              </div>
            </div>
            <div className="square-shimmer mt-2">
              
            </div>
          </div> */}
					<Row>
						{isLoading ? (
							<GridCardSkeleton count={6} cardHeight={200} />
						) : isError ? (
							<div className="mt-2 error-image-cont error-cont">
								<img src={post.errorSmall} alt="404 Not Found" width={200} />
							</div>
						) : searchuserList.length === 0 ? (
							UserWithAds.map((item, index) => {
								// Check if the current item is an ad
                               console.log("itemmmwww", item);

								if (item.isAd) {
									return (
										<Col md={12} key={`people-ad-${index}`}>
											<PeopleFeedAds />
										</Col>
									);
								}

								// Skip rendering if the current user matches the logged-in user
								if (userUid === item.userUid) {
									return null;
								}

								const isUserFollowed =
									followedCompanies[item.userUid] || item.isFollowedByYou;
							   
								return (
									<Col
										md={6}
										key={`user-${index}`}
										className="d-flex align-items-stretch"
									>
										<div className="PeopleCard  HuzPeopleCard" style={{ width: "100%" }}>
											<div className="PeopleCardHeader">
												{/* <div className="ProfilebadgePeople">
																<h6>#WillingToWork</h6>
																</div> */}
												{item?.openToStatus === "ToWork" ? (
													<div className="ProfilebadgePeople ProfilebadgePeopleWillingToWork">
														<h6>#{t("User Profile.WillingToWork")}</h6>
													</div>
												) : item?.openToStatus === "ToHire" ? (
													<div className="ProfilebadgePeople ProfilebadgePeopleWeAreHiring">
														<h6>#{t("User Profile.WeAreHiring")}</h6>
													</div>
												) : item?.openToStatus === "Freelance" ? (
													<div className="ProfilebadgePeople ProfilebadgePeopleFreelancing">
														<h6>#{t("User Profile.Freelancing")}</h6>
													</div>
												) : null}
												<img
													src={
														item.backGroundImage === null ||
															item.backGroundImage === ""
															? people.background
															: item.backGroundImage
													}
													alt=""
													width="100%"
													height="130px"
												/>
												<div className="overlay"></div>
												<div className="centerAlignment">
													<Link to={`/User/${item.userUid}/${item.slug}`}>
														<div
															className="ProfileImageWrapper"
															style={{
																background:
																	item?.openToStatus === "ToWork"
																		? "linear-gradient(90deg, rgba(0, 39, 96, 1) 35%, rgba(172, 4, 248, 1) 100%)"
																		: item?.openToStatus === "ToHire"
																			? "linear-gradient(140deg, rgba(0, 189, 47, 1) 33%, rgba(0, 50, 126, 1) 100%)"
																			: item?.openToStatus === "Freelance"
																				? "linear-gradient(140deg, rgba(0, 189, 47, 1) 33%, rgba(135, 0, 0, 1) 100%)"
																				: "transparent",
																padding: "4px",
																borderRadius: "50%",
																display: "inline-block",
																animation: "gradientBorder 3s linear infinite",
																backgroundSize: "200% 200%",
															}}
														>
															<img
																src={item?.profilPic || people.DefaultProfile}
																alt=""
																style={{
																	borderRadius: "50%",
																	width: "60px",
																	height: "60px",
																	display: "block",
																}}
																onError={handleProfileImageError}
															/>
														</div>
													</Link>
													<div className="d-block d-md-flex align-items-baseline justify-content-between">
														<div>
															<div className="mainCardText mb-0">
																<Link to={`/User/${item.userUid}/${item.slug}`}>
																	<h1>{item.fullName}</h1>
																</Link>
															</div>
															<div className="mainCardText">
																<h1 className="gradient-heading f-12">
																	<span >{item.nameTag}</span> </h1>

															</div>
															<div>
																<div className="mainCardTex people-titl userName">
																	{item.title === null || item.title === "" ? (
																		<>
																			{shortMutualList[item.userUid] && (
																				<div className="d-flex mt- ms-2 Outercircle-container align-items-center">
																					<div className="circle-container">
																						{shortMutualList[item.userUid]?.pics?.map(
																							(pic, picIndex) => (
																								<img
																									src={pic}
																									alt={`Circle ${picIndex + 1}`}
																									className="circle-img mt-1"
																									key={picIndex}
																									onError={handleProfileImageError}
																								/>
																							)
																						)}
																					</div>
																					<div className={`f-12 mt- text HuzText   ${shortMutualList?.[item.userUid]?.count === 1 ? 'ms-2' : 'ms-0'}`} >
																						{(shortMutualList[item.userUid]?.text?.length > 25 ? shortMutualList[item.userUid]?.text.slice(0, 25) + "..." : shortMutualList[item.userUid]?.text)}

																					</div>
																				</div>
																			)}
																		</>) :
																		<h1 class=" text-light " style={{ marginLeft: "5px" }}>
																			{(item.title.length > 30 ? item.title?.slice(0, 30) + "..." : item.title)}
																		</h1>
																	}
																</div>

																<div className="cardSubText">
																	<h1 >{item.headLine}</h1>
																</div>

															</div>
														</div>
													</div>

												</div>

											</div>
											<div className="PeopleCardContainer p-2 ms- d-flex justify-content-around align-items-baseline">

												<div className="follower-button text-end" style={{ display: "contents" }}>
													{item.userUid !== userid ? (
														<PeopleInteraction
															userUid={item.userUid}
															isFollowedByYou={item?.isFollowedByYou}
															isConnectedByYou={item?.isConnectedByYou}
															getUserProfileList={getUserProfileList}
															index={index}
															item={item}
															searchuserList={searchuserList}
														/>
													) : ""}

													{item.follwersCounts >= 10 ? (
														<div className="cardSubText d-flex justify-content-end mt-2">
															<h1>{item.follwersCounts} {t("People.Followers")}</h1>
														</div>
													) : ""}
												</div>
											</div>
										</div>
									</Col>
								);
							})
						) : (
							searchuserList.map((item, index) => {
								if (userUid === item.userUid) {
									return null;
								}

								const isUserFollowed =
									followedCompanies[item.userUid] || item.isFollowedByYou;

								return (
									<Col md={6} key={`search-${index}`}>
										<div className="PeopleCard">
											<div className="PeopleCardHeader">
												<img
													src={
														item.backGroundImage === null ||
															item.backGroundImage === ""
															? people.background
															: item.backGroundImage
													}
													alt=""
													width="100%"
													height="120px"
												/>
												<div className="overlay"></div>
												<div className="centerAlignment">
													<Link to={`/User/${item.userUid}/${item.slug}`}>
														<div
															className="ProfileImageWrapper"
															style={{
																background:
																	item?.openToStatus === "ToWork"
																		? "linear-gradient(90deg, rgba(0, 39, 96, 1) 35%, rgba(172, 4, 248, 1) 100%)"
																		: item?.openToStatus === "ToHire"
																			? "linear-gradient(140deg, rgba(0, 189, 47, 1) 33%, rgba(0, 50, 126, 1) 100%)"
																			: item?.openToStatus === "Freelance"
																				? "linear-gradient(140deg, rgba(0, 189, 47, 1) 33%, rgba(135, 0, 0, 1) 100%)"
																				: "transparent",
																padding: "4px",
																borderRadius: "50%",
																display: "inline-block",
																animation: "gradientBorder 3s linear infinite",
																backgroundSize: "200% 200%",
															}}
														>
															<img
																src={item?.profilPic || people.DefaultProfile}
																alt=""
																style={{
																	borderRadius: "50%",
																	width: "60px",
																	height: "60px",
																	display: "block",
																}}
																onError={handleProfileImageError}
															/>
														</div>
													</Link>
													<div className="d-block d-md-flex align-items-baseline justify-content-between">
														<div>
															<div className="mainCardText mb-0">
																<Link to={`/User/${item.userUid}/${item.slug}`}>
																	<h1>{item.fullName}</h1>
																</Link>
															</div>
															<div className="mainCardText">
																<h1>{item.nameTag}</h1>
															</div>
															<div>
																{/* <div className="mainCardText people-title">
														<h1 className="ms-0">{item.title}</h1>
													</div> */}
																<div className="mainCardTex people-titl userName">
																	{item.title === null || item.title === "" ? (
																		<>
																			{shortMutualList[item.userUid] && (
																				<div className="d-flex mt- ms-2 Outercircle-container align-items-center">
																					<div className="circle-container">
																						{shortMutualList[item.userUid]?.pics?.map(
																							(pic, picIndex) => (
																								<img
																									src={pic}
																									alt={`Circle ${picIndex + 1}`}
																									className="circle-img mt-1"
																									key={picIndex}
																									onError={handleProfileImageError}
																								/>
																							)
																						)}
																					</div>
																					<div className={`f-12 mt- text ${shortMutualList?.[item.userUid]?.count === 1 ? 'ms-2' : 'ms-0'}`} >
																						{(shortMutualList[item.userUid]?.text?.length > 25 ? shortMutualList[item.userUid]?.text.slice(0, 25) + "..." :
																							shortMutualList[item.userUid]?.text)}

																					</div>
																				</div>
																			)}
																		</>) :
																		<h1 className="ms-0">
																			{(item.title.length > 40 ? item.title?.slice(0, 40) + "..." : item.title)}
																		</h1>
																	}
																</div>
																<div className="cardSubText">
																	<h1>{item.headLine}</h1>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="PeopleCardContainer p-2 d-flex align-items-baseline justify-content-between">

												<div className="follower-button" style={{ display: "contents" }}>
													{item.userUid !== userid ? (
														<PeopleInteraction
															userUid={item.userUid}
															isConnectedByYou={item?.isConnectedByYou}
															isFollowedByYou={item.isFollowedByYou}
															getUserProfileList={getUserProfileList}
															index={index}
															item={item}
															searchuserList={searchuserList}

														/>
													) : ""}
													{item.follwersCounts >= 10 ? (

														<div className="cardSubText d-flex justify-content-end mt-2 ">
															<h1>{item.follwersCounts} {t("People.Followers")}</h1>
														</div>
													) : ""}
												</div>
											</div>
										</div>
									</Col>
								);
							})
						)}

						{isSearchMode ? (
							!isLoading && searchuserList.length === 0 && (
								<div className="text-center mt-4">
									<img src={post.errorSmall} alt="Result Not Found" width={150} />
								</div>
							)
						) : (
							!isLoading &&
							!nextBatchLoading &&
							!hasMoreData &&
							searchuserList.length > 0 && (
								<p className="text-center">{t("Newsfeed.No more data available")}</p>
							)
						)}


						{/* {hasMoreData ? (
							""
						) : (
							<p className="text-center">No more data available</p>
						)} */}
						{nextBatchLoading && (
							<div className="text-center">
								<img src={post?.loader} width={50} />
							</div>
						)}
					</Row>
				</div>
			</div>

			{showModal && (
				<div
					className="modal fade show postAdd"
					tabIndex="-1"
					role="dialog"
					style={{ display: "block" }}
				>
					<div className="modal-dialog  modal-dialog-centered " role="document">
						<div className="modal-content d-flex justify-content-around p-2">
							<div className="modalBorder d-flex justify-content-between align-items-center p-2">
								<h6>
									{t("modals.Are you sure you want to unfollow")}
									<b>{selectedItem?.fullName}</b>
								</h6>
								<CloseSharpIcon
									className="material-symbols-sharp me-2 pointer"
									onClick={() => {
										handleUnfollowCloseModal();
									}}
								/>
							</div>

							<div className="text-end mt-2">
								<button
									color=""
									className="closebtn"
									onClick={() => handleConfirmAction()}
								>
									{t("Recommendations.Unfollow")}
								</button>
							</div>
						</div>
					</div>
				</div>
			)}

			{followModal && <ModalForGuest closeModalData={closeModalData} />}

			<SuccessToast
				show={showToast}
				message={toastMessage}
				onClose={() => setShowToast(false)}
			/>

			<WarningToast
				show={showWarningToast}
				message={warningToastMessage}
				onClose={() => setShowWarningToast(false)}
			/>

			<ErrorToast
				show={showErrorToast}
				message={ErrorToastMessage}
				onClose={() => setShowErrorToast(false)}
			/>
		</>
	);
};

export default People;
